import React, { useEffect, useState } from "react";
import InitialBoqTable from "./InitialBoqTable";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { numberWithCommas } from "../../../../utils";
import { fetchData } from "../../../../features/fetch/fetchSlice";
import SubsidizedBoqTable from "./standardization/SubsidizedBoqTable";
import VerifiedReportTable from "../../verified/VerifiedReport/VerifiedReportTable";

function Boq({ handleExpand, expand }) {
  const urlTotal = "api/v2/flid/projects/getBoQTotals";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { activeObjexpIsp, activeObjexpressions, dataTotal } = useSelector(
    (state) => ({
      activeObjexpIsp: state.obj.activeObj["expressionIsp"],
      dataTotal: state.fetch.data[urlTotal] || [],
      activeObjexpressions: state.obj.activeObj["expressions"],
    })
  );

  const handleStandardize = () => {
    navigate("/standanrdized-list");
  };

  const [initialBoq, setInitialBoq] = useState(true);
  const [active, setActive] = useState("Initial");
  const handleInitial = () => {
    setInitialBoq(true);
    setActive("Initial");
  };
  const handleStandandization = () => {
    setInitialBoq(false);
    setActive("Starndardized");
  };

  const handleVerification = () => {
    setInitialBoq(false);
    setActive("Verified");
  };

  async function fetchBoqTotalsData() {
    await dispatch(
      fetchData({
        url: urlTotal,
        projectBidId: activeObjexpIsp?.projectBidId,
        limit: null,
        start: 0,
      })
    );
  }
  useEffect(() => {
    fetchBoqTotalsData();
  }, []);
  return (
    <div className={`${expand && "white_card mt-[1.75rem]"}`}>
      <div className={`flex items-center justify-between mt-[1.75rem] `}>
        <div className="details_h !text-[1rem]">
          Bill of Quantities: {activeObjexpIsp?.microIrrigationPartnerName}{" "}
        </div>
        <div className="flex items-center gap-x-[1.25rem] font-interSans">
          <span
            className="underline font-[400] text-[.75rem] text-[#424242] cursor-pointer"
            onClick={handleExpand}
          >
            {expand ? "Collpase" : "Expand"}
          </span>
          <span
            className={` underline font-[700] text-[.75rem] text-darkBlue cursor-pointer`}
            onClick={handleStandardize}
          >
            Standardize
          </span>
        </div>
      </div>

      <div className="flex items-center gap-x-[.62rem]  ">
        <div
          onClick={handleInitial}
          className={`${
            expand && "w-[70px]"
          } inline-flex cursor-pointer font-interSans mt-[1.75rem] h-[1.75rem] px-2 py-1 justify-center items-center gap-[0.1875rem] 
      rounded-[0.5625rem]   bg-[#9EB0CA] ${
        active === "Initial" && "border border-black"
      }`}
        >
          Initial
        </div>

        {activeObjexpIsp?.projectBidStatus !=
          "SUBMITTED_FOR_STANDARDIZATION" && (
          <div
            onClick={handleStandandization}
            className={`${
              expand && "w-[70px]"
            } cursor-pointer inline-flex  font-interSans mt-[1.75rem] h-[1.75rem] px-2 py-1 justify-center items-center gap-[0.1875rem]
              rounded-[0.5625rem] bg-[#9EB0CA] ${
                active === "Starndardized" && "border border-black"
              }`}
          >
            Standardized
          </div>
        )}

        {(activeObjexpressions?.projectStatus === "VERIFIED" ||
          activeObjexpressions?.projectStatus === "REJECTED") && (
          <div
            onClick={handleVerification}
            className={`${
              expand && "w-[70px]"
            } cursor-pointer inline-flex  font-interSans mt-[1.75rem] h-[1.75rem] px-2 py-1 justify-center items-center gap-[0.1875rem]
              rounded-[0.5625rem] bg-[#9EB0CA] ${
                active === "Verified" && "border border-black"
              }`}
          >
            Verification Report
          </div>
        )}
      </div>

      {initialBoq && active != "Verified" ? (
        <>
          <div className="rounded-[.75rem] border border-lightBlue mt-[1rem] p-[.625rem] font-interSans">
            <div className="py-[1rem]">
              <div className="flex items-center justify-between forgot-text !text-[#393939]">
                <span>Subtotal</span>
                <span>KES</span>
              </div>
              <div className="flex justify-end items-end text-end text-black1 text-[1rem]  font-[600]">
                {numberWithCommas(dataTotal?.projectBoqTotalOriginal)}
              </div>
            </div>
          </div>
          <div className="font-interSans font-[700] text-[.75rem] text-black1 mt-[1.63rem]">
            {activeObjexpIsp?.projectDescription}
          </div>
          <InitialBoqTable />
        </>
      ) : !initialBoq && active != "Verified" ? (
        <>
          {" "}
          <div className="rounded-[.75rem] border border-lightBlue mt-[1rem] p-[.625rem] font-interSans">
            <div className="py-[1rem]">
              <div className="flex items-center justify-between forgot-text !text-[#393939]">
                <span>Subtotal</span>
                <span>KES</span>
              </div>
              <div className="flex justify-end items-end text-end text-black1 text-[1rem]  font-[600]">
                {numberWithCommas(dataTotal?.projectBoqTotalStandardized)}
              </div>
            </div>
          </div>
          <div className="font-interSans font-[700] text-[.75rem] text-black1 mt-[1.63rem]">
            {activeObjexpIsp?.projectDescription}
          </div>
          <SubsidizedBoqTable />
        </>
      ) : !initialBoq && active === "Verified" ? (
        <VerifiedReportTable />
      ) : null}
    </div>
  );
}

export default Boq;
